/* eslint-disable no-param-reassign */
import { Grid, Input } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { getTilesetHeightOffsetMatrix } from "../../functions/getTilesetHeightOffsetMatrix";
import { Custom3DTileset } from "../../types/CesiumMapItems";
import AdjustmentSlider from "./AdjustmentSlider";

interface Props {
  tilesets: Custom3DTileset[];
  onHeightOffsetChange: (val: number) => void;
}

export const HeightOffsetAdjustment = ({
  tilesets,
  onHeightOffsetChange,
}: Props): JSX.Element => {
  const { t } = useTranslation("cesium");
  const [offset, setOffset] = React.useState(
    tilesets[0].additionalHeightOffset,
  );
  const [inputValue, setInputValue] = React.useState(
    tilesets[0].additionalHeightOffset.toString(),
  );

  const sliderMin = -50000;
  const sliderMax = 50000;
  const sliderStep = 1;

  React.useEffect(() => {
    onHeightOffsetChange(offset);
    setInputValue(offset.toString());
    tilesets.forEach((ts) => {
      ts.modelMatrix = getTilesetHeightOffsetMatrix(
        ts,
        ts.comparisonLevelOffset + offset,
      );
    });
  }, [onHeightOffsetChange, offset, tilesets]);

  const handleInputChange = React.useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      setInputValue(event.target.value);
      if (
        event.target.value !== undefined &&
        event.target.value !== null &&
        Number.isInteger(+event.target.value)
      ) {
        setOffset(+event.target.value);
      }
    },
    [],
  );

  return (
    <Grid container item xs={12} alignItems="center">
      <Grid item xs={8}>
        <AdjustmentSlider
          value={offset}
          onChange={setOffset}
          title={t("additional-height-offset")}
          min={sliderMin}
          max={sliderMax}
          step={sliderStep}
        />
      </Grid>
      <Grid item xs={3} sx={{ ml: 3 }}>
        <Input
          value={inputValue}
          inputProps={{
            step: sliderStep,
            min: sliderMin,
            max: sliderMax,
          }}
          type="number"
          onChange={handleInputChange}
        />
      </Grid>
    </Grid>
  );
};
